export enum SignalQuality {
  BAD = 'bad',
  CORRECT = 'correct'
}
